
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M20.463 2.515a17.491 17.491 0 1017.02 17.948c.005-.155.007-.31.007-.463a17.245 17.245 0 00-17-17.485zm.017 31.473a13.994 13.994 0 1113.6-14.375c0 .128.007.257.007.387a13.8 13.8 0 01-13.6 13.988z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      